<template>
  <div class="footer">
    <div class="foot">
      <div class="hover_">
        <a href="http://www.jeesit.com/about.html" target="_blank">关于我们</a>
        <span>|</span>
        <a href="http://www.jeesit.com/services.html" target="_blank"
          >加入我们</a
        >
        <span>|</span>
        <a href="http://www.jeesit.com/contact.html" target="_blank"
          >联系我们</a
        >
      </div>
      <p>
        声明：“杰宜斯云”服务平台系武汉杰宜斯信息科技有限公司（以下称：我司）为客户提供的增值服务平台，<br />
        该平台主要作用有数据分析及展示，我司不会对客户数据进行抓取、存储，不会使用客户数据进行盈利性商业活动,<br />
        我司所有开放行为均会在客户认可、自主的前提下进行，随时接受客户监督。
      </p>

      <div class="code">
        <!-- <div>
          <div
            style="display: inline-block;padding: 5px;background-color: #fff;height: 75px;"
          >
            <img
              style="width: 75px;"
              src="https://yunsrvwebapi.jeesit.com/img/cloud.png"
              alt=""
            />
          </div>
          <b style="margin-top: 15px;">扫码关注云服务公众号</b>
        </div> -->
        <div>
          <b>扫码关注武汉杰宜斯科技公众号</b>
          <img
            style="border: 0;"
            src="http://www.jeesit.com/img/erweima.png"
            alt=""
          />
        </div>

        <div style="margin-left: 60px;">
          <b style="width: 85px;margin-left:0;">技术认证</b>
          <img style="border: 0;" src="../../assets/images/huawei.png" alt="" />
        </div>
      </div>
    </div>
    <li class="f_bottom">
      Copyright © 2019 武汉杰宜斯信息科技有限公司<br /><a
        href="https://beian.miit.gov.cn/"
        target="_blank"
        >鄂ICP备14015145号-1</a
      >
    </li>
  </div>
</template>

<script>
import './style.css';
export default {
  components: {},

  data() {
    return {};
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/footer/index.vue